import React from "react";

/**
 * Container für den Hauptbereich (obere Navigation, Content und untere Buttonbar) in der Betriebsakte.
 * @returns {JSX.Element}
 * @constructor
 */
export default function EABetriebsakteMainContainer(props) {
    return <div id={"betriebsakteMainContainer"} {...props} />;
}
